export const queryKeys = {
    getEmployees: "getEmployees",
    getEmployee: "getEmployee",
    getEmployeeLookups: "getEmployeeLookups",
};

export const employeeStatus = {
    active: "b4ebae4b-5541-ef11-8eed-00155d112802",
    inActive: "2dc8c558-5541-ef11-8eed-00155d112802",
};

export const leadershipEnrollmentStatus = {
    none: 0,
    stepUpYear1: 1,
    stepUpYear2: 2,
    leadership: 3
};

export function getLeadershipEnrollmentStatusIcon(value: number | undefined | null): string {
    switch (value) {
        case leadershipEnrollmentStatus.stepUpYear1: {
            return "bi bi-star"
        }
        case leadershipEnrollmentStatus.stepUpYear2: {
            return "bi bi-star-half"
        }
        case leadershipEnrollmentStatus.leadership: {
            return "bi bi-star-fill"
        }
        default: {
            return ""
        }
    } 
};

export function getLeadershipEnrollmentStatusColor(value: number | undefined | null): string {
    switch (value) {
        case leadershipEnrollmentStatus.stepUpYear1: {
            return "bi bi-star"
        }
        case leadershipEnrollmentStatus.stepUpYear2: {
            return "bi bi-star-half"
        }
        case leadershipEnrollmentStatus.leadership: {
            return "bi bi-star-fill"
        }
        default: {
            return "transparent"
        }
    }
};

export const PAGE_SIZE = 25;
